import { Job, JobService } from '../../job';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService, ConstantService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';

@Component({
    selector: 'app-job',
    templateUrl: './job.component.html',
    styleUrls: ['./job.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class JobComponent implements OnInit {
    jobCategories: any;
    jobLevels: any;
    countries: any;
	states: any;
    locationCategories: any;

	constructor(
		private constantService: ConstantService,
		private primengConfig: PrimeNGConfig,
		private jobService: JobService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.job = data.job,
			this.jobCategories = jobService.jobCategories;
			this.jobLevels = jobService.jobLevels;
			this.countries =  this.constantService.countries;
			this.states =  this.constantService.states;
			this.locationCategories = this.constantService.locations;
			this.statuses = jobService.statuses;
	}

	@Input() job: Job;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	jobId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'jobId': [],
		'locationId': [],
		'jobCategory': [],
		'jobLevel': [],
		'jobTitle': [],
		'jobDesc': [],
		'salaryRange': [],
		'adrStreetNumber': [],
		'adrStreetName': [],
		'adrUnit': [],
		'adr2': [],
		'adrCity': [],
		'adrCountry': [],
		'adrState': [],
		'adrPostalCode': [],
		'adrIsland': [],
		'status': [],
	};
	
	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole job object
		if (this.job) {
			this.jobId = this.job.jobId;
			this.fixDates();
			this.form1.patchValue(this.job);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.jobId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.jobService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.job = res.data.job;
						this.doAdd.emit(this.job);
					},
					(err: any) => {
						console.log('job-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('job: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.jobService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.job = res.data.job;
						this.doUpdate.emit(this.job);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.jobService.delete(this.job.jobId)
				.subscribe(
					(res: any) => {
						console.log('job-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.job);
					},
					(err: any) => {
						console.log('job-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			jobId: [this.jobId],
			locationId: [1],
			jobCategory: [],
			jobLevel: [],
			jobTitle: [],
			jobDesc: [],
			salaryRange: [],
			adrStreetNumber: [],
			adrStreetName: [],
			adrUnit: [],
			adr2: [],
			adrCity: [],
			adrCountry: [],
			adrState: [],
			adrPostalCode: [],
			adrIsland: [],
			status: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.job.jobDate = moment(this.job.jobDate).toDate();
	}
	
}
